import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpyderideComponent } from './simple-icons-spyderide.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpyderideComponent ],
    exports:      [ SimpleIconsSpyderideComponent ],
    bootstrap:    []
})
export class SimpleIconsSpyderideModule {}
